import { addDays, compareAsc, isToday, parseISO } from 'date-fns';
import type React from 'react';
import { useWindowWidth } from '@shared/hooks';
import type { Program, ProgramList } from '@shared/types/programs';
import type { Mode } from '@src/library/types/programs';
import { ButtonDay } from './frames';
import * as st from './ChooseDay.module.scss';

type Props = {
  selectedDay: number;
  onSelect: (day: number) => void;
  changeMode: (mode: Mode) => void;
  program?: Program;
};

type ProgramType = Program | ProgramList | undefined;

const ChooseDay: React.FC<Props> = ({ selectedDay, onSelect, changeMode, program }) => {
  // const { program } = useProgram(programId);
  const windowWidth = useWindowWidth();

  // const generateDays = (program: ProgramType) => {
  // 	// Для оплаченной программы создаем количество дней, указанное в рекомендации
  // 	if (!program || !('duration' in program)) return 0;
  // 	const { duration, individual, is_paid } = program;
  // 	let days = duration;

  // 	if (
  // 		individual &&
  // 		typeof individual.days_period === 'number' &&
  // 		individual.days_period !== duration
  // 	) {
  // 		days = individual.days_period;
  // 	}

  // 	return days;
  // };

  const days = Array.from({ length: 7 }, (x, i) => i + 1);

  const isProgramRented = (program: ProgramType) => {
    if (!program || !program.is_paid || !program.individual) return false;
    if (!program.individual || !program.individual.start_date) return false;
    return true;
  };

  const today = (program: ProgramType, dayValue: number) => {
    if (!isProgramRented(program)) return false;
    const date = addDays(parseISO(program!.individual?.start_date as string), dayValue - 1);
    return isToday(date);
  };

  const notPassed = (program: ProgramType, dayValue: number) => {
    if (!isProgramRented(program)) return false;
    if (today(program, dayValue)) return true;
    const date = addDays(parseISO(program!.individual?.start_date as string), dayValue - 1);
    return compareAsc(date, new Date()) === 1 ? true : false;
  };

  const finishDay = (program: ProgramType, dayValue: number) => {
    if (!isProgramRented(program)) return false;
    const date = addDays(parseISO(program!.individual?.start_date as string), dayValue - 1);
    return date < new Date();
  };

  return (
    <div className={st.wrapper}>
      <div className={st.days}>
        <p className={st.label}>Выберите день для просмотра:</p>
        {days.map((dayValue) => (
          // <div >
          <ButtonDay
            key={dayValue}
            dayValue={dayValue}
            // isSelected={selectedDay === dayValue}
            isSelected={selectedDay === dayValue}
            onClick={() => {
              onSelect(dayValue);
              windowWidth <= 768 && changeMode(undefined);
            }}
            // notPassed={notPassed(program, dayValue)}
            // finishDay={finishDay(program, dayValue)}
          />
          // </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseDay;
